import get from 'transmute/get';
export const getPopOpenWelcomeMessage = get('popOpenWelcomeMessage');